import React from "react";
import { Navigate, NavigateFunction, Route, Routes } from "react-router-dom";
import { observer } from "mobx-react";
import PaySettingsPaymentMethods from "./PaySettingsPaymentMethods";
import { AuthService, Loader, withRouter } from "@mindmemobile/mm-shared-global";
import { CountryStore, ItemsStore, RolesAndPermissionStore } from "../../../shared/store";
import {
  DashboardTopBar,
  DashboardTopRightSide,
  ItemContentArea,
} from "../../../shared/components"; 
import { MerchantAccountStore } from "../../../modules/merchantAccounts";

interface IProps {
  itemStore: ItemsStore; 
  navigate: NavigateFunction;
  rolesAndPermissionStore: RolesAndPermissionStore;
  merchantAccountStore: MerchantAccountStore;
}

const PaymentSettingsRoutes: React.FC<IProps> = ({
  itemStore, 
  rolesAndPermissionStore,
  merchantAccountStore,
}) => {
  function renderDetails(node: React.ReactNode, showItemRightContent = false) {
    const content = showItemRightContent ? (
      <DashboardTopRightSide itemStore={itemStore} />
    ) : (
      <></>
    );
    return (
      <>
        <DashboardTopBar
          itemStore={itemStore}
          rightContent={<>{content}</>}
          merchantAccountStore={merchantAccountStore}
          rolesAndPermissionStore={rolesAndPermissionStore}
        />
        <ItemContentArea
          itemStore={itemStore}
          node={node}
          showMerchantAccountNotificationBar={merchantAccountStore.hasNotificationBar()}
        />
      </>
    );
  }
  if (!itemStore.countryStore.countryDataLoaded) {
    return <>{new Loader().loaderComponent}</>;
  }
  return (
    <Routes>
      <Route
        path={`/`}
        element={
          <>
            {renderDetails(
              <PaySettingsPaymentMethods
                itemStore={itemStore} 
                accountId={AuthService.authData.accountId}
                rolesAndPermissionStore={rolesAndPermissionStore}
              />
            )}
          </>
        }
      />

      <Route path="*" element={<Navigate to="/app/activity" />} />
    </Routes>
  );
};
export default withRouter(observer(PaymentSettingsRoutes));
